export function modalOverlayConfig({ spacing }) {
    return {
        container: { background: "transparent" },
        contentBoxContentPadding: `${spacing.horizontalSpacing.horizWhiteSpacingmd}px ${spacing.verticalSpacing.vertWhiteSpacingmd}px`
    };
}
